import React from "react";
import { List, CreateButton } from "@refinedev/mui";
import { DataGrid } from "@shared/components/DataGrid";

import { CsvExportButton, FilterDropdown } from "@shared/components";
import { CreateVoucherModal, EditVoucherModal, VoucherListFilters } from "@modules/vouchers/components";

import {  useVoucherList } from "./controller";
import { useVoucherListColumns } from "./columns";

export const VoucherList = React.memo(() => {
  const {
    rows,
    loading,
    selectedRows,
    dataToExport,
    createVoucherModalRef,
    editVoucherModalRef,
    setSelectedRows,
    refetch,
    translate,
    tableProps
  } =  useVoucherList();

  const columns = useVoucherListColumns(refetch, translate, editVoucherModalRef);

  return (
    <List
      headerButtons={
        <>
          <FilterDropdown
            initialValues={{
              search: "",
            }}
          >
            <VoucherListFilters />
          </FilterDropdown>

          <CsvExportButton
            data={dataToExport}
            filename="vouchers.csv"
            isDisabled={loading || !rows}
          />

          <CreateButton onClick={() => createVoucherModalRef.current?.open()} />
        </>
      }
    >
      <DataGrid
        {...tableProps}
        rows={rows}
        columns={columns}
        loading={loading}
        checkboxSelection
        rowSelectionModel={selectedRows}
        onRowSelectionModelChange={(selectionModel) =>
          setSelectedRows(selectionModel as number[])
        }
      />

      <CreateVoucherModal
        modalRef={createVoucherModalRef}
        onComplete={refetch}
      />

      <EditVoucherModal
        modalRef={editVoucherModalRef}
        onComplete={refetch}
      />
    </List>
  );
});
